var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6789_44870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8822 72 72 55.8822 72 36C72 16.1177 55.8822 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8822 16.1177 72 36 72Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7016 21.9092L22.8094 31.4717H32.8641L24.7359 37.392L27.8437 46.9545L19.7016 41.0482L11.5594 46.9545L14.6812 37.392L6.53906 31.4717H16.5937L19.7016 21.9092Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6799 55.7577L40.3033 52.8327L36.7877 54.1968L38.8268 51.0327L36.4502 48.0937L40.0924 49.064L42.1455 45.8999L42.3424 49.6687L45.9986 50.639L42.4689 51.989L42.6799 55.7577Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4049 47.1796L48.5299 43.5796L45.4502 41.3999L49.2189 41.3437L50.3299 37.7437L51.5533 41.3155L55.3221 41.2733L52.2986 43.5233L53.508 47.0952L50.4283 44.9155L47.4049 47.1796Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7748 26.4236L52.1154 29.8127L54.8154 32.4424L51.0889 31.908L49.4295 35.283L48.7826 31.5705L45.042 31.0361L48.3889 29.2783L47.742 25.5518L50.442 28.1814L53.7748 26.4236Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.778 16.1577L42.4968 19.9124L45.9983 21.3327L42.328 22.2327L42.0608 26.0015L40.078 22.7952L36.4077 23.6952L38.8405 20.8124L36.8437 17.6202L40.3452 19.0405L42.778 16.1577Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6789_44870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChina);
export default __webpack_public_path__ + "static/media/china.a70984939e414baf9943cb65045d061b.svg";
export { ForwardRef as ReactComponent };